module.exports = __webpack_public_path__ + "img/icon33.93f5fc31.png";